import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  PUBLISHERS: {
    GET_STATS: undefined,
    API: {
      GET_STATS: apiResourceActionCreator('publishers')
    }
  }
})

export const apiAction = (authToken) => commonApiActions.authenticated.get(`${API_ENDPOINT}/stats`, authToken, actions.publishers.api.getStats)

export function* getStats() {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken));
}

const configuration = {
  name: 'getStats',
  action: actions,
  sagas: getStats,
  reducers: {
    request: (state, action) => {
      return Object.assign({}, state, {
        publisherStats: [],
        isFetching: true
      });
    },
    success: (state, action) => {
      return Object.assign({}, state, {
        isFetching: false,
        publisherStats: action.payload.publishers,
        error: null
      });
    },
    failed: (state, action) => {
      return Object.assign({}, state, {
        isFetching: false,
        error: action.payload.error
      });
    },
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/publisher/configurations/getStats.js